var map = {
	"./dashboard/premium-courses.png": 12297,
	"./details_close.png": 33441,
	"./details_open.png": 32005,
	"./email-template/10.jpg": 19955,
	"./email-template/11.jpg": 56790,
	"./email-template/3.png": 52545,
	"./email-template/4.png": 34830,
	"./email-template/invoice-1/1.png": 21457,
	"./email-template/invoice-1/sign.png": 85249,
	"./email-template/invoice-3/bg-0.png": 14498,
	"./email-template/invoice-3/sign.png": 11007,
	"./email-template/pdfs.png": 77921,
	"./forms/user.png": 92157,
	"./login/1.jpg": 76369,
	"./login/2.jpg": 44166,
	"./login/3.jpg": 34275,
	"./login/icon.png": 21997,
	"./login/login_bg.jpg": 87665,
	"./logo/SSFM2.png": 53649,
	"./logo/landing-logo.png": 41925,
	"./logo/login-bg-new.jpg": 82538,
	"./logo/login-bg-resized.jpg": 98980,
	"./logo/login-bg.jpg": 39707,
	"./logo/logo-dark-resized.png": 5585,
	"./logo/logo-dark.png": 19186,
	"./logo/logo-icon.png": 25485,
	"./logo/logo-sm-resized.png": 80309,
	"./logo/logo-sm.png": 3430,
	"./logo/logo.png": 26447,
	"./logo/logo7.png": 34624,
	"./logo/logo_dark.png": 91832,
	"./logo/techbrain2.png": 89328,
	"./other-images/bg-profile.png": 63887,
	"./other-images/boxbg.jpg": 70138,
	"./other-images/coming-soon-bg.jpg": 81823,
	"./other-images/maintenance-bg.jpg": 58465,
	"./slider/1.jpg": 31719,
	"./slider/10.jpg": 65639,
	"./slider/11.jpg": 9802,
	"./slider/2.jpg": 52792,
	"./slider/3.jpg": 60053,
	"./slider/4.jpg": 49166,
	"./slider/5.jpg": 75627,
	"./slider/6.jpg": 7932,
	"./slider/7.jpg": 5305,
	"./slider/8.jpg": 15682,
	"./slider/9.jpg": 35679,
	"./social-app/social-image.png": 68709,
	"./switch/square-gray.png": 96710,
	"./switch/square.svg": 16044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34002;